// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertPrice } from '@/_helper/mapper';
import { getShortWeekday } from '@/_helper/bookingDetailsHelper';

// Styles
import './travelFactsFull.scss';

class TravelFactsFull extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDetails: false,
            data: null,
        };

        this.getDestination = this.getDestination.bind(this);
        this.getTravelDate = this.getTravelDate.bind(this);
        this.getTraveller = this.getTraveller.bind(this);
    }

    componentDidMount() {
        if (storage.get('bookingData') != null && storage.get('bookingData').data != null) {
            this.setState({
                data: storage.get('bookingData').data,
                bookingNumber: storage.get('bookingNumber'),
            });
        }
    }

    getDestination() {
        if (this.state != null) {
            const { data } = this.state;

            let returnString;

            if (data !== null && data.searchParams.destinationDescription !== undefined) {
                returnString = (
                    <div className="region">
                        Ihre gebuchte Reise nach <b>{data.searchParams.destinationDescription}</b>
                    </div>
                );
            }

            return returnString;
        }
    }

    getTravelDate() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.searchParams !== undefined &&
                data.searchParams.depDate !== undefined &&
                data.searchParams.retDate !== undefined
            ) {
                return (
                    <div className="date">
                        {data.searchParams.depDate} - {data.searchParams.retDate}
                    </div>
                );
            }
        }
    }

    getTraveller() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.searchParams.adults !== undefined &&
                data.searchParams.babies !== undefined &&
                data.searchParams.children !== undefined
            ) {
                const travellerCount =
                    parseInt(data.searchParams.adults) +
                    parseInt(data.searchParams.babies) +
                    parseInt(data.searchParams.children);

                return (
                    <div className="traveller">
                        {travellerCount} {travellerCount > 1 ? 'Personen' : 'Person'}
                    </div>
                );
            }
        }
    }

    getHotelDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (data?.frontendParams?.hotelDetails[0] !== undefined) {
                const hotelDetails = data.frontendParams.hotelDetails;

                return (
                    <div className="hotel box">
                        <div className="line">
                            <div>
                                <span className="icon hotel"></span>
                            </div>
                            <div className="booking-info hotel booked">
                                <div className="title">Hotel</div>
                                {hotelDetails.map((hotel, index) => {
                                    const starsContainer = [];

                                    for (var i = 0; i < hotel.category; i++) {
                                        starsContainer.push(
                                            <i className="material-icons" key={i}>
                                                star
                                            </i>
                                        );
                                    }

                                    return (
                                        <div className="details-info" key={index}>
                                            <div className="flex flex-middle">
                                                <div>{hotel.name}</div>
                                                <div className="category flex flex-middle" category={hotel.category}>
                                                    {starsContainer}
                                                </div>
                                            </div>
                                            <div>{hotel.room}</div>
                                            <div>{hotel.meal}</div>
                                            <div>
                                                {hotel.checkIn} - {hotel.checkOut}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getFlightDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams !== undefined &&
                data.frontendParams?.flightDetails?.inbound !== undefined &&
                data.frontendParams?.flightDetails?.outbound !== undefined
            ) {
                const flightDetailsOutbound = data.frontendParams.flightDetails.outbound;
                const flightDetailsInbound = data.frontendParams.flightDetails.inbound;

                return (
                    <div className="flight box">
                        <div className="line">
                            <div>
                                <span className="icon flight"></span>
                            </div>
                            <div className="booking-info flight booked">
                                <div className="title">Flug</div>
                                <div className="details-info">
                                    <div className="outbound">
                                        {flightDetailsOutbound.map((value, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <div>
                                                        {value.depAirportDescription} ({value.depAirportCode}) -{' '}
                                                        {value.arrAirportDescription} ({value.arrAirportCode}) -{' '}
                                                        {value.carrier}
                                                        {value.flightNumber}
                                                    </div>
                                                    <div>
                                                        {value.depDate} - {value.depTime} Uhr
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>

                                    <div className="inbound">
                                        {flightDetailsInbound.map((value, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <div>
                                                        {value.depAirportDescription} ({value.depAirportCode}) -{' '}
                                                        {value.arrAirportDescription} ({value.arrAirportCode}) -{' '}
                                                        {value.carrier}
                                                        {value.flightNumber}
                                                    </div>
                                                    <div>
                                                        {value.depDate} - {value.depTime} Uhr
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getExcursionDetails() {
        if (this.state != null) {
            const { data } = this.state;
            const excursions = data?.frontendParams?.excursions;

            if (excursions !== undefined && excursions.length > 0) {
                return (
                    <div className="excursion box">
                        <div className="line">
                            <div>
                                <span className="icon excursion"></span>
                            </div>
                            <div className="booking-info booked">
                                <div className="title">Ausflug</div>
                                <div className="details-info">
                                    {excursions?.length > 0 &&
                                        excursions.map((value, index) => {
                                            const title = value.title ?? value.description.split(' -')[0];

                                            return (
                                                <div
                                                    key={`excursion-${index}`}
                                                    className={value.state === 'OK' ? 'active' : 'inactive'}>
                                                    {index > 0 && <hr />}
                                                    {title !== undefined && (
                                                        <div>
                                                            {title}
                                                            {value.state !== 'OK' && (
                                                                <span className="chip storno"></span>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div>
                                                        {getShortWeekday(value.startDate) + '., ' + value.startDate}
                                                    </div>
                                                    <div>
                                                        {value.participants.length &&
                                                            value.participants.length + ' Pers.'}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getPriceDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (data !== null && data.frontendParams?.price !== undefined) {
                return (
                    <div className="total-price box">
                        <div>{convertPrice(data.frontendParams.price.total, 0, 2)}</div>
                        <div className="small-print">Bisheriger Gesamtpreis für alle Reisenden</div>
                    </div>
                );
            }
        }
    }

    render() {
        return (
            <section className={`travel-facts-full ${this.state.showDetails ? 'active' : ''} `}>
                <div className="head" onClick={(e) => this.setState({ showDetails: !this.state.showDetails })}>
                    {this.getDestination()}
                    <div className="row">
                        {this.getTravelDate()}
                        {this.getTraveller()}
                    </div>
                </div>
                {this.state.showDetails && (
                    <div className="content">
                        {window.$browserInfo.device !== 'mobile' && (
                            <div className="close" onClick={(e) => this.setState({ showDetails: false })}>
                                <i className="material-icons no-print">close</i>
                            </div>
                        )}
                        {this.getHotelDetails()}
                        <div className="transfer box">
                            <div className="line">
                                <div>
                                    <span className="icon transfer"></span>
                                </div>
                                <div className="booking-info transfer booked">
                                    <div className="title">Transfer</div>
                                    <div className="details-info">
                                        <div>SHUTTLE Transfer ab Flughafen</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.getFlightDetails()}

                        {this.getExcursionDetails()}

                        {this.getPriceDetails()}
                    </div>
                )}
            </section>
        );
    }
}

export default TravelFactsFull;
